import {
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Input,
  message,
  Modal,
  Row,
  Skeleton,
  Upload,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import WorkExperience from "./Components/WorkExperience/WorkExperience";
import Education from "./Components/Education/Education";
import Project from "./Components/Projects/Projects";
import SkillsOverview from "./Components/Skills/Skills";
import axios from "axios";
import { schema } from "./data/data";
import JSONViewer from "./Components/JSONViewer/JSONViewer";
import sampleResume from "../../assets/Siddharth-Kharwar.pdf";

const { Dragger } = Upload;

function Parser() {
  const [data, setData] = useState();
  const [loading, setIsLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [messageApi, contextHolder] = message.useMessage();

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message || "Resume Parsed Successfully!",
      duration: 5,
    });
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "Error parsing resume!",
      duration: 5,
    });
  };

  const onFileUpload = async (values) => {
    setIsLoading(true);
    success("Parsing Resume... This may take a while.");
    const formData = new FormData();
    formData.append("resume", values.fileList[0].originFileObj);
    axios
      .post(`https://assistant-rag.azurewebsites.net/parse-resume`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        success("Resume Parsed Successfully!");
        setData(response.data.data);
      })
      .catch(() => error())
      .finally(() => setIsLoading(false));
  };

  return (
    <Flex vertical style={{ padding: "20px" }}>
      {contextHolder}
      <Card bordered>
        <Dragger
          multiple={false}
          style={{ marginBottom: "10px" }}
          onChange={onFileUpload}
          beforeUpload={() => false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to upload your resume
          </p>
          <p className="ant-upload-hint">
            This app will parse your resume into a structured format using LLM.
          </p>
        </Dragger>
        {!data && (
          <a href={sampleResume} download="Siddharth Kharwar">
            <Button type="primary">Download Sample Resume</Button>
          </a>
        )}
        {loading && <Skeleton active />}
        {data && (
          <Flex vertical>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <a href={sampleResume} download="Siddharth Kharwar">
                <Button style={{ marginRight: "10px" }}>
                  Download Sample Resume
                </Button>
              </a>
              <Button type="primary" onClick={showModal}>
                View JSON
              </Button>
              <Modal
                title="JSON Viewer"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width="80%"
                style={{
                  top: 20,
                }}
              >
                <JSONViewer schema={schema} data={data} />
              </Modal>
            </div>
            <div style={{ marginBottom: "10px" }}>
              <Divider orientation="left">Basic Information</Divider>
              <Row justify="space-between" style={{ marginBottom: "10px" }}>
                <Col span={7}>
                  <Input addonBefore="Name" value={data.name} />
                </Col>
                <Col span={7}>
                  <Input
                    addonBefore="Email"
                    value={data.contact_information.email}
                  />
                </Col>
                <Col span={7}>
                  <Input
                    addonBefore="Phone"
                    value={data.contact_information.phone_number}
                  />
                </Col>
              </Row>
              <Row justify="space-between">
                <Col span={7}>
                  <Input
                    addonBefore="Portfolio"
                    value={data.contact_information.portfolio}
                  />
                </Col>
                <Col span={7}>
                  <Input
                    addonBefore="LinkedIn"
                    value={data.contact_information.linkedin}
                  />
                </Col>
                <Col span={7}>
                  <Input
                    addonBefore="Github"
                    value={data.contact_information.github}
                  />
                </Col>
              </Row>
            </div>
            <div style={{ marginBottom: "10px" }}>
              <Divider orientation="left">Summary</Divider>
              <Row justify="space-between" style={{ marginBottom: "10px" }}>
                <Col span={24}>
                  <TextArea value={data.summary} rows={5} />
                </Col>
              </Row>
            </div>
            <div>
              <Divider orientation="left">Work Experience</Divider>
              {data.work_experience.map((experience, key) => (
                <div key={key} style={{ marginBottom: 10 }}>
                  <WorkExperience experience={experience} />
                </div>
              ))}
            </div>
            <div>
              <Divider orientation="left">Education</Divider>
              {data.education.map((edu, key) => (
                <div key={key} style={{ marginBottom: 10 }}>
                  <Education education={edu} />
                </div>
              ))}
            </div>
            <div>
              <Divider orientation="left">Projects</Divider>
              {data.projects.map((project, key) => (
                <div key={key} style={{ marginBottom: 10 }}>
                  <Project project={project} />
                </div>
              ))}
            </div>
            <div>
              <Divider orientation="left">Skills Overview</Divider>
              <div style={{ marginBottom: 10 }}>
                <SkillsOverview
                  skills={{
                    hard_skills_keywords: data.hard_skills_keywords,
                    soft_skills_keywords: data.soft_skills_keywords,
                  }}
                />
              </div>
            </div>
          </Flex>
        )}
      </Card>
    </Flex>
  );
}

export default Parser;
